import moment from "moment";
import DateBookRepository from "../../Repository/DateBookRepository";
import SalesRepository from "../../Repository/SalesRepository";
import Repo from "../../Repository/Repo";
import { Toast } from "../components/Toast";
import BillsRepository from "../../Repository/BillsRepository";


export const getStockReport = async (start, end, token) => {
  try {
    const { data } = await Repo.default({
      request: {
        method: "stockReport",
        data: {
            company_code: localStorage.getItem("companyCode")
        }
    }
    });

  

    return data.response.data; // Return the data
  } catch (error) {
    console.error("Failed to fetch items or send email notification:", error.message);
    // toast.error("An error occurred while fetching items!");
    throw error; // Re-throw the error for handling in calling code
  }
};

export const getCombinedSales = async (start, end, token) => {
  try {
    let { data } = await Repo.sales({
      request: {
        method: "combinedSales",
        data: {
          company_code: localStorage.getItem("companyCode"),
          startDate: start && end ? moment(start).format("DD-MM-YYYY") : "",
          endDate: start && end ? moment(end).format("DD-MM-YYYY") : "",
          next_page_token: token,
        },
      },
    });
    return data;
  } catch (err) {
    console.log(err);
    Toast("error", "Error");
  }
};
export const getRangeSales = async (start, end, token) => {
  const companyCode = localStorage.getItem("companyCode");
  return DateBookRepository.datebookModel({
    request: {
      method: "getBillsRangeDateBookByCompany",
      data: {
        company_code: companyCode,
        startDate: start ? moment(start).format("DD-MM-YYYY") : "",
        endDate: end ? moment(end).format("DD-MM-YYYY") : "",
        next_page_token: token,
        all_reports: start && end ? false : true,
      },
    },
  });
};

export const loadBills = async (noToken, start, end) => {
  // if (state.current_page_token && !state.next_page_token) {
  //   setState((prev) => ({
  //     ...prev,
  //     hasMore: !prev.hasMore,
  //   }));
  // } else {
  return BillsRepository.billsModel({
    request: {
      method: "getBillsSearch",
      data: {
        company_code: localStorage.getItem("companyCode"),
        startDate: start ? moment(start).format("DD-MM-YYYY") : "",
        endDate: end ? moment(end).format("DD-MM-YYYY") : "",
        // next_page_token: noToken,
        search:""
      },
    },
  });
  // setState((prev) => ({
  //   ...prev,
  //   bills: [...prev.bills, ...data.response.data.items],
  //   current_page_token: data.response.data.current_page_token || "",
  //   next_page_token: data.response.data.next_page_token || "",
  // }));
  // }
};

export const getSalesProfit = async (start, end) => {
  const companyCode = localStorage.getItem("companyCode");
  return SalesRepository.salesModel({
    request: {
      method: "getSalesProfit",
      data: {
        company_code: companyCode,
        startDate: start ? moment(start).format("DD-MM-YYYY") : "",
        endDate: end ? moment(end).format("DD-MM-YYYY") : "",
      },
    },
  });
};
